module.exports = __webpack_public_path__ + "img/index-logo.a1f71679.png";